import {
  OnboardingQuestion,
  OnboardingQuestionDetail,
  SaveOnboardingParams,
  SetupGuideResponse
} from './types';

import axiosInstance from 'services/common/instance';

export const getAllOnboardingService = async (): Promise<OnboardingQuestion[]> => {
  const response = await axiosInstance.get('onboarding-flow');
  return response.data.data;
};

export const getOnboardingByIdService = async (id: number): Promise<OnboardingQuestionDetail> => {
  const response = await axiosInstance.get(`onboarding-flow/${id}`);
  return response.data.data;
};

export const saveOnboardingService = async (data: SaveOnboardingParams): Promise<void> => {
  await axiosInstance.post('onboarding-flow', data);
};

export const getSetupGuideService = async (): Promise<SetupGuideResponse> => {
  const response = await axiosInstance.get('onboarding-flow/setup-guide');
  return response.data.data;
};
